type CheckCodeResponse = {
    somAntwoord: string;
};

export class CalculatorService {
    public async calculate(som: string): Promise<string> {
        const response: Response = await fetch(`${VITE_API_URL}calculator/calculate-som?som=${encodeURIComponent(som)}`);
        const data: CheckCodeResponse = await response.json() as CheckCodeResponse;

        return data.somAntwoord;
    }
}
